module.exports = __webpack_public_path__ + "assets/img/gilde-equity-management.18901e01.png";